import { render, staticRenderFns } from "./exp-remark.vue?vue&type=template&id=eefe5ab2&scoped=true"
import script from "./exp-remark.vue?vue&type=script&lang=js"
export * from "./exp-remark.vue?vue&type=script&lang=js"
import style0 from "./exp-remark.vue?vue&type=style&index=0&id=eefe5ab2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eefe5ab2",
  null
  
)

export default component.exports